import { render, staticRenderFns } from "./TaskSummary.vue?vue&type=template&id=796ad846&scoped=true"
import script from "./TaskSummary.vue?vue&type=script&lang=js"
export * from "./TaskSummary.vue?vue&type=script&lang=js"
import style0 from "./TaskSummary.vue?vue&type=style&index=0&id=796ad846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ad846",
  null
  
)

export default component.exports